export default __webpack_public_path__ + "ffbf98d0ba475b658013b08763e2c9c1.png";